import { DownOutlined } from '@ant-design/icons';

export const getOption = (value: string, lang: string, customStyle?: string) => {
   const getLabel = (es: string, en: string, fr: string) => (lang === 'es' ? es : lang === 'en' ? en : fr);

   switch (value) {
      case 'co':
         return renderOption('🇨🇴', 'co', getLabel('Colombia', 'Colombia', 'Colombie'), customStyle);
      case 'en':
         return renderOption('🇺🇸', 'eu', getLabel('Estados Unidos', 'United States', 'États-Unis'), customStyle);
      case 'es-ES':
         return renderOption('🇪🇸', 'es-ES', getLabel('España', 'Spain', 'Espagne'), customStyle);
      case 'br':
         return renderOption('🇧🇷', 'br', getLabel('Brasil', 'Brazil', 'Brésil'), customStyle);
      case 'ar':
         return renderOption('🇦🇷', 'ar', getLabel('Argentina', 'Argentina', 'Argentine'), customStyle);
      case 'pa':
         return renderOption('🇵🇦', 'pa', getLabel('Panamá', 'Panama', 'Panama'), customStyle);
      case 'cl':
         return renderOption('🇨🇱', 'cl', getLabel('Chile', 'Chile', 'Chili'), customStyle);
      case 'cr':
         return renderOption('🇨🇷', 'cr', getLabel('Costa Rica', 'Costa Rica', 'Costa Rica'), customStyle);
      case 'pe':
         return renderOption('🇵🇪', 'pe', getLabel('Perú', 'Peru', 'Pérou'), customStyle);
      case 'pr':
         return renderOption('🇵🇷', 'pr', getLabel('Puerto Rico', 'Puerto Rico', 'Porto Rico'), customStyle);
      case 'fr':
         return renderOption('🇫🇷', 'fr', getLabel('Francia', 'France', 'France'), customStyle);
      case 'es':
      default:
         return renderOption('🇲🇽', 'mx', getLabel('México', 'Mexico', 'Mexique'), customStyle);
   }
};

/* Helper para no repetir el mismo JSX */
const renderOption = (flag: string, aria: string, label: string, customStyle?: string) => (
   <div
      style={{
         width: '100%',
         textOverflow: 'ellipsis',
         whiteSpace: 'nowrap',
         overflow: 'hidden',
         display: 'flex',
         justifyContent: 'space-between',
         alignItems: 'center',
      }}>
      <div className={customStyle || ''}>
         <p>
            <span role='img' aria-label={aria}>
               {flag}
            </span>
            {label}
         </p>
      </div>
      <div>
         <DownOutlined style={{ color: '#D5D5D5' }} />
      </div>
   </div>
);
